
import ModalWindow from '@/ui-kit/components/modal/modal-window';
import { ModalSlotName, ModalViewType } from '@/ui-kit/components/modal/enums';
import ModalCommonProps from '@/ui-kit/components/modal/mixins/ModalCommonProps';
import WindowSize from '@/ui-kit/mixins/windowSize';
import { track } from '@/utils/analytics';
import { NotesModalEvent } from '@/constants/AnalyticEvents';
import Typography from '@/ui-kit/components/typography';
import { TypographyType } from '@/ui-kit/components/typography/enums';
import Button from '@/ui-kit/components/button';
import Gutter from '@/ui-kit/components/gutter';
import {
  StyleSizeType,
  StylePositionType,
  StyleColorSchemeType,
  StyleFontWeightType,
} from '@/ui-kit/styles/enums';
import Checkbox from '@/ui-kit/components/checkbox';
import Rating from '@/ui-kit/components/form/controls/components/rating';
import TextArea from '@/ui-kit/components/form/controls/components/textarea';
import { DEFAULT_NOTES, FavouritesRatingCategory } from './constants';
import { TooltipMessage } from '@/ui-kit/components/tooltip/enum';
import { ControlPropertyType } from '@/ui-kit/components/form/controls/enums';
import GridContainer from '@/components/page-specific/favourites/main-section/grid-container';
import IconHintTooltip from '@/components/shared/tooltips/icon-hint-tooltip';
import { IconHintTooltipProperty } from '@/components/shared/tooltips/icon-hint-tooltip/enum';

export default {
  name: 'MyNotes',
  components: {
    IconHintTooltip,
    ModalWindow,
    Rating,
    Typography,
    Gutter,
    Checkbox,
    TextArea,
    Button,
    GridContainer,
  },
  mixins: [ModalCommonProps, WindowSize],
  data() {
    return {
      notes: {
        ...this.modalData.notes || DEFAULT_NOTES,
      },
      TypographyType,
      StyleSizeType,
      StylePositionType,
      StyleColorSchemeType,
      StyleFontWeightType,
      FavouritesRatingCategory,
      TooltipMessage,
      ModalSlotName,
      ModalViewType,
      IconHintTooltipProperty,
    };
  },
  computed: {
    title() {
      const { unit, address } = this.modalData;

      return unit ? `${unit} ${address}` : address;
    },
    customNotesTextAreaProps() {
      return {
        [ControlPropertyType.Placeholder]: 'Add your thoughts about the property here...',
        [ControlPropertyType.Value]: this.notes.notes,
      };
    },
    responsiveModalOptions() {
      const viewType = this.isSmallerThan(StyleSizeType.Small)
        ? ModalViewType.FullWidth
        : ModalViewType.FitContent;

      return {
        ...this.modalOptions,
        viewType,
      };
    },
  },
  methods: {
    async handleSaveNotesClick() {
      track(NotesModalEvent.ButtonClick);
      this.closeHandler(this.notes);
    },
    handleRatingChange(name, value) {
      const ratings = { ...this.notes.ratings };
      ratings[name] = value;
      this.notes.ratings = ratings;
    },
    handleNotesInput(value) {
      this.notes.notes = value;
    },
    handleSendFeedbackToggle(value) {
      this.notes.sendFeedback = !value;
    },
  },
};
